import { render, staticRenderFns } from "./monitoringKanban.vue?vue&type=template&id=1728e9d6&scoped=true&"
import script from "./monitoringKanban.vue?vue&type=script&lang=js&"
export * from "./monitoringKanban.vue?vue&type=script&lang=js&"
import style0 from "./monitoringKanban.vue?vue&type=style&index=0&id=1728e9d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728e9d6",
  null
  
)

export default component.exports